import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import { Api } from './api/axiosInstant'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import SweetAlertIcons from 'vue-sweetalert-icons';
import VueCurrencyInput from "vue-currency-input";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(SweetAlertIcons);
Vue.use(VueCurrencyInput);

Vue.config.productionTip = false
Vue.prototype.$apiConfig = new Api(axios)
Vue.prototype.$api_url = 'https://budgeting.inet.co.th/api'

Vue.prototype.$group_biz_tax_id = ["0105557099769" ,"0105548134654" ,"0105565071941"]
Vue.prototype.$group_biz_tax_id_dashboard_budget = ["0105557099769" ,"0105548134654" ,"0105565071941","0105560082464"]
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
